<template>
    <div id="contactcontent">
        <h2>Contact</h2>

        <p>Peter de Jeu</p>
        <img id="peter" src="../assets/peter.jpg" alt="Peter de Jeu">
        <p>Telefoon: <a id="callme" href="tel:+31653817802">06 – 5381 7802</a></p>

        <p>Email: <a href="mailto:groenehartansichtkaarten@ziggo.nl">groenehartansichtkaarten@ziggo.nl</a></p>

    </div>
</template>

<script>
    export default {
        name: "Contact"
    }
</script>

<style scoped lang="scss">
    #contactcontent {
        p {
            font-size: 1.5em;
            text-align: start;
            @media screen and (max-device-width: 1200px) {
                font-size: 1.2em;
            }
        }

        @media not all and (max-device-width: 1200px) {
            margin: 30px 20em 0 23em;
            #callme {
                color: inherit;
                text-decoration: inherit;
            }
        }

        #peter {
            max-width: 10em;
        }
    }
</style>